'use client';
import type { Assign } from '@ark-ui/react';
import { Slider } from '@ark-ui/react';
import { type SliderVariantProps, slider } from '@terra/ui-styled-system';
import type { ComponentProps, HTMLStyledProps } from '@terra/ui-styled-system';
import { createStyleContext } from './utils/create-style-context';

const { withProvider, withContext } = createStyleContext(slider);

export type RootProviderProps = ComponentProps<typeof RootProvider>;
export const RootProvider = withProvider<
  HTMLDivElement,
  Assign<
    Assign<HTMLStyledProps<'div'>, Slider.RootProviderProps>,
    SliderVariantProps
  >
>(Slider.RootProvider, 'root');

export type RootProps = ComponentProps<typeof Root>;
export const Root = withProvider<
  HTMLDivElement,
  Assign<Assign<HTMLStyledProps<'div'>, Slider.RootProps>, SliderVariantProps>
>(Slider.Root, 'root');

export const Control = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, Slider.ControlProps>
>(Slider.Control, 'control');

export const Label = withContext<
  HTMLLabelElement,
  Assign<HTMLStyledProps<'label'>, Slider.LabelProps>
>(Slider.Label, 'label');

export const MarkerGroup = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, Slider.MarkerGroupProps>
>(Slider.MarkerGroup, 'markerGroup');

export const Marker = withContext<
  HTMLSpanElement,
  Assign<HTMLStyledProps<'span'>, Slider.MarkerProps>
>(Slider.Marker, 'marker');

export const Range = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, Slider.RangeProps>
>(Slider.Range, 'range');

export const Thumb = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, Slider.ThumbProps>
>(Slider.Thumb, 'thumb');

export const Track = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, Slider.TrackProps>
>(Slider.Track, 'track');

export const ValueText = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'span'>, Slider.ValueTextProps>
>(Slider.ValueText, 'valueText');

export {
  SliderContext as Context,
  SliderHiddenInput as HiddenInput,
} from '@ark-ui/react';
